import {TOAST_PORTAL} from './portalIds';
import {usePortalElement} from './usePortalElement';

export function useToastPortalElement() {
  return usePortalElement(TOAST_PORTAL);
}
